import FsVideoEventHandler from "./FsVideoEventHandler";

class FsVideoWcEndcard {
	constructor() {}

	initEndcards() {
        FsVideoEventHandler.onVideoEnd((data) => this.render(data));
        FsVideoEventHandler.onVideoPause((data) => this.render(data));
        FsVideoEventHandler.onVideoProgress((data) => this.pauseIfNeeded(data));
        FsVideoEventHandler.addEventListener('onForcePlay', (data) => this.play(data));
	}

	pauseIfNeeded(data) {
        if (!data || !data.player || !data.player.wcEndcard) return;
        if (data.player.vid === data.player.videoinfo.id) return;

        let endcardElem = document.getElementById(data.player.elem + '_wc-endcard');
        if (!endcardElem) return;

        data.player.pause();
	}

	play(data) {
        if (!data || !data.player || !data.player.wcEndcard) return;
        if (data.player.vid === data.player.videoinfo.id) return;

        data.player.play();
	}

	render(data) {
		if (!data || !data.player || !data.player.wcEndcard) return;

		if (data.player.vid !== data.player.videoinfo.id) return;

		// Check if it is match center page
		if (document.body.classList.contains('single-fox_big_board') && window.location.href.indexOf('soccer') > -1) return;

		let playerElem = document.getElementById(data.player.elem);

		if (!playerElem) return;

		let wcEndcard = data.player.wcEndcard;

		let endcardLayoutId = data.player.elem + '_wc-endcard';
		let endcardLayoutCloseId = endcardLayoutId + '_close';
		let endcardFullCavId = endcardLayoutId + '_fc';

		let isSmallContainer = playerElem.clientHeight < 300;

		let fullCoverageUrl = wcEndcard.fullCoverageUrl + '?utm_campaign=wc_promo&utm_source=wc_endcard';
		let isEmbed = playerElem.baseURI.indexOf('video-embed') !== -1;
		let target = isEmbed ? '_blank' : '_self';

		let endcardLayout = [
			'<div id="' + endcardLayoutId + '" class="wc-endcard_container" style="z-index: 1001; font-family: Antenna, Helvetica Neue, Arial, sans-serif;">',
				'<div class="wc-endcard_card" ' + (isSmallContainer ? 'style="padding: 20px;"' : '') + '>',
					'<div class="wc-endcard_description">',
						'More highlights, full replay and stats available for this match',
					'</div>',
					'<a href="' + fullCoverageUrl + '" id="' + endcardFullCavId + '" class="wc-endcard_full-coverage" target="'+ target +'">',
						'See Full Coverage',
					'</a>',
					'<div class="wc-endcard_close-btn">',
						'<span id="' + endcardLayoutCloseId + '" style="">close</span>',
					'</div>',
				'</div>',
			'</div>'
		];

		if (!isSmallContainer) {
			let flags = [
				'<div class="wc-endcard_flags">',
					'<div class="wc-endcard_flags_flag">',
						'<img src="' + wcEndcard.homeTeamCountryImgSrc + '">',
					'</div>',
					'<div class="wc-endcard_flags_vc">vs</div>',
					'<div class="wc-endcard_flags_flag">',
						'<img src="' + wcEndcard.awayTeamCountryImgSrc + '">',
					'</div>',
				'</div>',
			].join('');
			endcardLayout.splice(2, 0, flags);
		}

		endcardLayout = endcardLayout.join('');

		playerElem.insertAdjacentHTML('afterend', endcardLayout);

		let endcardElem = document.getElementById(endcardLayoutId);
		let endcardCloseElem = document.getElementById(endcardLayoutCloseId);

		let endcardFullCavElem = document.getElementById(endcardFullCavId);

		let seconds = 0;
		let timeInterval = setInterval(() => {
			if (seconds === 9) {
				endcardCloseClick();
				return;
			}

			seconds++;
		}, 1000);

        let endacardFullCavClick = () => window.open(fullCoverageUrl, target);
		
		if(!isEmbed) {
			endcardFullCavElem.addEventListener('click', endacardFullCavClick);
		}


		let endcardCloseClick = (e) => {
			endcardCloseElem.removeEventListener('click', endcardCloseClick);
			!isEmbed && endcardFullCavElem.removeEventListener('click', endacardFullCavClick);
			clearInterval(timeInterval);
			endcardElem.remove();
            FsVideoEventHandler.dispatchEvent('onForcePlay', {player: data.player});
		};

		endcardCloseElem.addEventListener('click', endcardCloseClick);

	}
}

export default new FsVideoWcEndcard();



// WEBPACK FOOTER //
// ./assets/components/platformPlayer/FsVideoWcEndcard.js